import { render } from "./StartRedirect.vue?vue&type=template&id=47d4f0d8&ts=true"
import script from "./StartRedirect.vue?vue&type=script&lang=ts"
export * from "./StartRedirect.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/StartRedirect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47d4f0d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47d4f0d8', __exports__)) {
    api.reload('47d4f0d8', __exports__)
  }
  
  module.hot.accept("./StartRedirect.vue?vue&type=template&id=47d4f0d8&ts=true", () => {
    api.rerender('47d4f0d8', render)
  })

}


export default __exports__